import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BaseURL } from '../config/apiUrl';
import { Get } from '../Axios/AxiosFunctions';
import { leadSourceOptions } from '../constant/commonData';

/**
 * The selectable lead sources: the fixed list plus any a broker added.
 *
 * Every screen used to import the static `leadSourceOptions` directly, so a source added
 * by a broker was invisible in the filter, and a listing saved with one reopened showing a
 * BLANK lead source, because the reload does `options.find(o => o.value == stored)` and the
 * stored value was not in the static list.
 *
 * Falls back to the static list if the request fails, so a dropdown is never empty.
 *
 * The token is passed EXPLICITLY. Get() takes it as its second positional argument and does
 * not read it from anywhere else, and its 401 handler clears persist:root and redirects to
 * /login — so an unauthenticated call here would not fail quietly, it would sign the user out
 * of whichever listing screen they were on.
 */
export default function useLeadSources() {
  const { access_token: accessToken, company_id: companyId } = useSelector(
    (state) => state.authReducer,
  );
  const [options, setOptions] = useState(leadSourceOptions);

  const load = async () => {
    if (!accessToken) return; // pre-login render: keep the static fallback, do not 401
    const res = await Get(BaseURL('business/lead-sources'), accessToken, companyId);
    const data = res?.data?.data;
    if (Array.isArray(data) && data.length) setOptions(data);
  };

  useEffect(() => {
    load();
  }, [accessToken, companyId]);

  return { leadSources: options, reloadLeadSources: load };
}
